import {SHAPE_TYPES} from '../../../../constant/shapes'

/**
 * @typedef {Object} ShapeItem
 * @property {SHAPE_TYPES} type - Shape type
 */
/**
 * @type {ShapeItem[]} BASIC_SHAPES
 */
export const BASIC_SHAPES = [
    {
        name: 'Square',
        type: SHAPE_TYPES.SQUARE,
    },
    {
        name: 'Circle',
        type: SHAPE_TYPES.CIRCLE,
    },
    {
        name: 'Triangle',
        type: SHAPE_TYPES.TRIANGLE,
    },
    {
        name: 'Pentagon',
        type: SHAPE_TYPES.PENTAGON,
    },
    {
        name: 'Hexagon',
        type: SHAPE_TYPES.HEXAGON,
    },
    {
        name: 'Round Rectangle',
        type: SHAPE_TYPES.ROUND_RECT,
    },
    {
        name: 'Star',
        type: SHAPE_TYPES.STAR,
    },
    {
        name: 'Plus',
        type: SHAPE_TYPES.PLUS,
    },
    {
        name: 'Tag Left',
        type: SHAPE_TYPES.TAG_LEFT,
    },
    {
        name: 'Tag Right',
        type: SHAPE_TYPES.TAG_RIGHT,
    },
    {
        name: 'Chevron Left',
        type: SHAPE_TYPES.CHEVRON_LEFT,
    },
    {
        name: 'Chevron Right',
        type: SHAPE_TYPES.CHEVRON_RIGHT,
    },
    {
        name: 'Arrow Left',
        type: SHAPE_TYPES.ARROW_LEFT,
    },
    {
        name: 'Arrow Right',
        type: SHAPE_TYPES.ARROW_RIGHT,
    },
]

/**
 * @type {ShapeItem[]} CUTOUT_SHAPES
 */
export const CUTOUT_SHAPES = [
    {
        name: 'Square Cutout',
        type: SHAPE_TYPES.SQUARE_CUTOUT,
    },
    {
        name: 'Circle Cutout',
        type: SHAPE_TYPES.CIRCLE_CUTOUT,
    },
    {
        name: 'Round Rectangle Cutout',
        type: SHAPE_TYPES.ROUND_RECT_CUTOUT,
    },
    {
        name: 'Star Cutout',
        type: SHAPE_TYPES.STAR_CUTOUT,
    },
    {
        name: 'Tag Left Cutout',
        type: SHAPE_TYPES.TAG_LEFT_CUTOUT,
    },
    {
        name: 'Tag Right Cutout',
        type: SHAPE_TYPES.TAG_RIGHT_CUTOUT,
    },
    {
        name: 'Chevron Left Cutout',
        type: SHAPE_TYPES.CHEVRON_LEFT_CUTOUT,
    },
    {
        name: 'Chevron Right Cutout',
        type: SHAPE_TYPES.CHEVRON_RIGHT_CUTOUT,
    },
    {
        name: 'Arrow Left Cutout',
        type: SHAPE_TYPES.ARROW_LEFT_CUTOUT,
    },
    {
        name: 'Arrow Right Cutout',
        type: SHAPE_TYPES.ARROW_RIGHT_CUTOUT,
    },
]

